import React from "react";
import "../StyleSheets/StyleSheetPages.css"; // Updated CSS file name

function FAQ() {
  return (
    <div className="stylesheetpage-container">
      <div className="stylesheetpage-box">
        <h2 className="stylesheetpage-title">Frequently Asked Questions</h2>
        <h5 >When can children take an admission test?</h5>
        <p>
          The children can take an admission test anytime except when school is
          closed.
        </p>

        <h5>Can applicants take an online admission test?</h5>
        <p>Admission tests are taken in school supervised by a staff member</p>

        <h5>
          For which grades do the students have to take an admission test?
        </h5>
        <p>
          There is admission test for students applying for grades above KG-1.
          Admission is granted based on the results of the tests, in
          particularly English, Science, Urdu (foreign nationals are exempted)
          and Mathematics. An interview for potential students with the Head of
          the section is compulsory.
        </p>

        <h5>What is the Fee Structure?</h5>
        <p>Kindly click the link below for fees structure.</p>
        <p>School Fee Structure</p>

        <h5>When will the new session start?</h5>
        <p>The classes of new session begins every year in September.</p>

        <h5>Do you offer O-Level or IGCSE?</h5>
        <p>
          We offer IGCSE in Grade 9 and 10 which is a globally recognized
          qualification.
        </p>

        <h5>Do you offer hostel facilities for students?</h5>
        <p>We don’t offer any hostel facilities for the students.</p>

        <h5>Do you have any other branches in any other cities?</h5>
        <p>Our school is exclusive for Bahria Town Rawalpindi/Islamabad</p>

        <h5>What extra-curricular activities are offered ?</h5>
        <p>
          Swimming, ballet and music classes are included in the time table.
          <br />
          We also offer wide variety of extra-curricular activities.
          <br />
          See the section in the <a> Club Activities</a>
        </p>

        <p>
          <a>Any Other Question?</a>
        </p>
      </div>
    </div>
  );
}

export default FAQ;
